import React, { useState, useEffect } from 'react';
import { useDispatch } from "react-redux";
import DataGrid, {
    Column,
    FilterRow,
    ColumnChooser,
    Paging,
    Selection,
    Scrolling,
    Export,
    Editing
} from 'devextreme-react/data-grid';
import * as AppActions from '../../../actions/AppActions';
import { Popup } from 'devextreme-react/popup';
import { Button } from 'devextreme-react/button';
import { ToastType } from "../../../constants/Constants";
import { showToast, parseDate, hasRole } from "../../../utils/Utils";
import './kullanici.scss';
import CustomStore from 'devextreme/data/custom_store';
import ArrayStore from 'devextreme/data/array_store';
import DataSource from 'devextreme/data/data_source';
import Request from "../../../components/api/Request";

const KullaniciRole = (props) => {

    const dispatch = useDispatch();

    const [formYetki, setFormYetki] = useState(
        {
            listele: hasRole("tanimlar|kullanici|listele"),    
            goruntule: hasRole("tanimlar|kullanici|goruntule"),  
            ekle: hasRole("tanimlar|kullanici|ekle"),  
            degistir: hasRole("tanimlar|kullanici|degistir"),  
            sil: hasRole("tanimlar|kullanici|sil"),  
            domainList: hasRole("tanimlar|kullanici|domainList"),    
            roleList: hasRole("tanimlar|kullanici|roleList"),    
            userDomainSave: hasRole("tanimlar|kullanici|userDomainSave"),    
            userRoleSave: hasRole("tanimlar|kullanici|userRoleSave")
        });

    const [roleDetail, setRoleDetail] = useState();
    const dataSource = new DataSource({
        store: new ArrayStore({
            data: roleDetail,
            key: 'id'
        })
    });

    let dataGrid = null;

    useEffect(() => {
        loadRoleDetail();
    }, [])

    const loadRoleDetail = () => {
        const request = new Request("/kullanici/getKullaniciRoleList/" + props.data.id, "GET");

        return request.run()
            .then(response => {
                if (response.data) {
                    setRoleDetail(response.data.data)
                }
            });
    }
    function kaydet(e) {


        let eksikBilgi = false;
        e.validationGroup.validators.map((a) => {
            if (a.validate().status !== "valid") {
                eksikBilgi = true;
            }
        }
        );
        if (eksikBilgi) {
            showToast('Zorunlu alanları kontrol ediniz', ToastType.ERROR, 500);
            return;
        }
        let data = roleDetail;

        let method = "POST"
        let url = "/kullanici/saveKullaniciRolList/" + props.data.id;

        const request = new Request(url, method, data);
        dispatch(AppActions.setLoading(true, "Kayıt işlemi yapılıyor.."));
        return request.run()
            .then(response => {
                dispatch(AppActions.setLoading(false, ""));
                if (response.data && response.data.data) {
                    props.hide();
                }
            });

    }


    return (
        <div >
            <DataGrid
                className="kullaniciRoleGrid"
                ref={ref => dataGrid = ref}
                width="100%"
                dataSource={dataSource}
                key="id"
                keyExpr="id"
                showBorders={true}
                focusedRowEnabled={true}
                allowColumnResizing={true}
                columnResizingMode={"widget"}
                columnAutoWidth={false}
            >
                <FilterRow visible={true} />
                <Scrolling columnRenderingMode="virtual" showScrollbar="always" />
                <Paging enabled={false} />
                <Editing
                    mode="cell"
                    allowUpdating={true}
                    startEditAction="click"
                />

                <Column dataField={'id'} width={90} caption={'Id'} dataType="number" visible={false} allowEditing={false} />
                <Column dataField={'name'} width={300} caption={'Adı'} dataType="string" visible={true} allowEditing={false} />
                <Column dataField={'enable'} width={90} caption={'Yetki'} dataType="boolean" visible={true} allowEditing={true} />

            </DataGrid>

            <Button
                width={1000}
                text="Save"
                type="success"
                stylingMode="contained"
                visible={formYetki.userRoleSave}
                onClick={kaydet}
            />
        </div>
    )
}

export default KullaniciRole;
